import http from '@/utils/http'
import qs from 'qs'
export const sysnewsgetnewlist = (params) =>{
    return http.postjson('/sysnews/getnewlist',params)
}
export const sysnewsgetnewdetail = (params) =>{
    return http.get('/sysnews/getnewdetail',params)
}